import { useEffect, useState } from 'react';
import { ExpirationService } from '../../../services/expiration/expirationService';
import { State } from '../../../type/entities/state-type';

/*--------------------------------------------------------------------------------------------------------
* EN: Hook to manage expiration management states fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de estados de gestión de vencimientos.
--------------------------------------------------------------------------------------------------------*/

const useExpirationManagementStates = () => {

    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchExpirationManagementStates = async () => {
        setIsLoading(true);
        try {
            const service = new ExpirationService();
            const response = await service.getExpirationManagementStatuses();
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: State & { unsatisfactoryStatus?: boolean; requiresKoReason?: boolean }) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                    statusOrder: data.statusOrder,
                    initialStatus: data.initialStatus,
                    unsatisfactoryStatus: data.unsatisfactoryStatus,
                    requiresKoReason: data.requiresKoReason,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching expiration management states:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchExpirationManagementStates();
    }, []);

    const getExpirationManagementStatesList = (notShowStatusID?: string | null) => {
        if (notShowStatusID) return data.filter((status) => status.value !== notShowStatusID);
        return data;
    };

    return { fetchExpirationManagementStates, getExpirationManagementStatesList, isLoadingExpirationManagementStates: isLoading };
}

export default useExpirationManagementStates;